import { panel_key } from './types';
import { applyFilterUiSettings, applyUiSettingsOrder } from '../ui-settings';
import { removeNulls } from 'utils';
function createPanelContent(items, internal_order, icons, hidden_name, should_filter) {
    const result = applyFilterUiSettings(applyUiSettingsOrder(items, internal_order, icons, hidden_name), should_filter);
    return result.length > 0 ? result : null;
}
export function getPanelsConfig(tab_key, device_config, device_ui_settings_details) {
    const { device_ui_settings, sorting_mode } = device_ui_settings_details;
    const panel_config = panel_key.map((key) => {
        const device_ui_settings_panel = device_ui_settings?.[tab_key]?.[key];
        const device_ui_settings_icon = device_ui_settings?.icons?.web_elements;
        const device_ui_settings_hidden_name = device_ui_settings?.hidden_name;
        const content = device_config[key];
        if (!content) {
            return null;
        }
        return [
            key,
            createPanelContent(content, device_ui_settings_panel?.internal_order || {}, device_ui_settings_icon || {}, device_ui_settings_hidden_name || {}, !sorting_mode),
        ];
    });
    return Object.fromEntries(removeNulls(panel_config));
}
export function getCustomPanels(panels_config, custom_panels) {
    const user_custom_panels = Object.fromEntries(Object.entries(custom_panels || {}).map(([custom_key, custom_panel]) => {
        const custom_panel_key = custom_key;
        const filtered_content = Object.fromEntries(Object.entries(panels_config).map(([content_key, panel_content]) => {
            const panel_content_key = content_key;
            //@ts-ignore
            const new_content = panel_content?.filter((card) => Object.keys(custom_panel.internal_order).includes(card.id.toString()));
            return [panel_content_key, new_content];
        }));
        const panel_details = {
            ...custom_panel,
            content: filtered_content,
        };
        return [custom_panel_key, panel_details];
    }));
    //@ts-ignore
    return user_custom_panels;
}
